import { gql, useMutation } from '@apollo/client';

import { GET_JOB_BY_ID } from './get-job-by-id.hook';

export const DELETE_JOB_SUPERVISORS_BY_IDS = gql`
  mutation deleteJobSupervisorsByIds($jobSupervisorsIds: [ObjectId!]!, $jobId: ObjectId!) {
    deleteJobSupervisorsByIds(jobSupervisorsIds: $jobSupervisorsIds, jobId: $jobId)
  }
`;

export const useDeleteJobSupervisorsByIds = () => {
  const [deleteJobSupervisorsByIds] = useMutation(DELETE_JOB_SUPERVISORS_BY_IDS, {
    refetchQueries: [GET_JOB_BY_ID],
  });

  return deleteJobSupervisorsByIds;
};
